<ngx-extended-pdf-viewer
     [src]="pdfFile"
     [height]="'auto'" 
     [textLayer]="true" 
     [showHandToolButton]="true" 
     [filenameForDownload]="'questions.pdf'"> 
</ngx-extended-pdf-viewer>
